// @flow
import React, {useState, type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'
import classNames from 'classnames'
import Comment from 'components/ui/icons/Comment'
import PremiumCallout from 'components/ui/PremiumCallout'
import IconButton from 'components/SideBar/ui/IconButton'
import styles from './index.scss'

import type {
  FreshChat_organization as Organization,
} from './__generated__/FreshChat_organization.graphql'

type Props = $ReadOnly<{
  organization: Organization,
}>

// NOTE: Although this is now HubSpot, not FreshDesk, I am choosing not to bother renaming the component.
function FreshChat({organization}: Props): Node {
  const [chatStatus, setChatStatus] = useState(false)
  const onClickFn = () => {
    if (organization.onRestrictedPlan)
      return

    if (window.HubSpotConversations) {
      if (chatStatus) {
        window.HubSpotConversations.widget.close()
        setChatStatus(false)
      } else {
        window.HubSpotConversations.widget.open()
        setChatStatus(true)
      }
    } else {
      /* eslint-disable-next-line no-alert */
      alert(I18n.t('dialogs.support.disable_adblock'))
    }
  }

  const buttonClass = classNames({[styles.premiumChatIcon]: organization.onRestrictedPlan})

  if (!organization.viewerIsMember)
    return null

  return (
    <div id="liveChatCallout" className={buttonClass}>
      <IconButton
        alt={I18n.t('side_nav.settings_section.fresh_chat.title')}
        onClick={onClickFn}
        theme="dark"
      >
        <Comment />
      </IconButton>
      {organization.onRestrictedPlan && <PremiumCallout callout="live_chat" target="liveChatCallout" enabled />}
    </div>
  )
}

export default (createFragmentContainer(FreshChat, {
  organization: graphql`
    fragment FreshChat_organization on Organization {
      onRestrictedPlan
      viewerIsMember
    }
  `,
}): RelayFragmentContainer<typeof(FreshChat)>)
